export const theme = {
  primary: "#00fff5",
  secondary: "#00adb5",
  nuetral: "#393e46",
  background: "#222831",
};
